import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import { configureRouter } from "./router/";
import store from "@/store/index";
import "./registerServiceWorker";
import dateFilter from "@/filters/date.filter";
import { configureOidc } from "@/store/services/security.service";
import { configureMessageHub } from "@/plugins/messageHub";
import { clear } from "idb-keyval";
import LodashPlugin from "@/plugins/lodash-plugin";
import { appPalette } from "@/theme/palette";

Object.entries(appPalette).forEach(([name, value]) => {
    const cssName = name.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
    document.documentElement.style.setProperty(`--app-color-${cssName}`, value);
});

const init = async function () {
    const isDev = process.env.NODE_ENV === "development";
    const mainOidc = await configureOidc();
    const router = await configureRouter();
    clear().then(() => {
        mainOidc.startup().then((ok) => {
            if (mainOidc.isAuthenticated) {
                configureMessageHub()
                    .then(() => {
                        console.log("MessageHub started");
                    })
                    .catch(() => {
                        console.log("MessageHub start error");
                        if (!isDev) {
                            mainOidc.signOut();
                        }
                    });
            }
            if (ok) {
                Vue.config.productionTip = false;
                Vue.filter("date", dateFilter);
                Vue.prototype.$oidc = mainOidc;
                Vue.use(LodashPlugin);

                new Vue({
                    vuetify,
                    router,
                    store,
                    render: (h) => h(App),
                }).$mount("#app");
            }
        });
    });
};

init();
